import React from "react";
import { exact, PropTypes } from "prop-types";
import Chart from "react-apexcharts";
import styles from "./TestCard.module.styl";
import svgIcons from "uikit/assets/svgIcons";

export default function TestCard({ testInfo }) {
    let bestResult = 0;
    let currentResult = 0;

    if (testInfo.moreIsBetter) {
        if (testInfo.currentResult > testInfo.bestResult) {
            currentResult = 100;
            bestResult = Math.round((testInfo.bestResult / testInfo.currentResult) * 100);
        } else {
            bestResult = 100;
            currentResult = Math.round((testInfo.currentResult / testInfo.bestResult) * 100);
        }
    } else {
        if (testInfo.currentResult > testInfo.bestResult) {
            bestResult = 100;
            currentResult = Math.round((testInfo.bestResult / testInfo.currentResult) * 100);
        } else {
            currentResult = 100;
            bestResult = Math.round((testInfo.currentResult / testInfo.bestResult) * 100);
        }
    }

    const options = {
        chart: {
            type: "bar",
            height: 100,
            toolbar: {
                show: false,
            },
        },
        colors: [
            function ({ value, seriesIndex, w }) {
                if (seriesIndex % 2 === 0) {
                    return "#082254";
                } else {
                    return "#FB9145";
                }
            },
        ],
        plotOptions: {
            bar: {
                borderRadius: 10,
                dataLabels: {
                    position: "top",
                },
                columnWidth: "60%",
                distributed: true,
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val + "%";
            },
            offsetY: -20,
            style: {
                fontSize: "12px",
                colors: ["#304758"],
            },
        },
        xaxis: {
            categories: [""],
            position: "top",
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            crosshairs: {
                fill: {
                    type: "gradient",
                    gradient: {
                        colorFrom: "#D8E3F0",
                        colorTo: "#BED1E6",
                        stops: [0, 100],
                        opacityFrom: 0.4,
                        opacityTo: 0.5,
                    },
                },
            },
            tooltip: {
                enabled: true,
            },
        },
        yaxis: {
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                show: false,
            },
        },
        legend: {
            show: false,
        },
        grid: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
    };

    const series = [
        {
            name: "",
            data: [currentResult, bestResult],
        },
    ];

    return (
        <div className={styles.container}>
            <div className={styles.chartAndName}>
                <div title={testInfo.title} className={styles.name}>
                    {testInfo.title}
                </div>
                <div className={styles.chart}>
                    <Chart options={options} series={series} type="bar" width="120" height="240" />
                </div>
            </div>
            <div className={styles.relativeResults}>
                <div className={styles.trainingResult}>
                    {testInfo.moreIsBetter ? (
                        testInfo.currentResult >= testInfo.bestResult ? (
                            <div className={styles.currentResult}>
                                {testInfo.currentResult} {testInfo.measureTypeTitle} (лидер)
                            </div>
                        ) : (
                            <div className={styles.results}>
                                <div className={styles.currentResult}>
                                    {testInfo.currentResult} {testInfo.measureTypeTitle} |
                                </div>
                                <div className={styles.bestResult}>
                                    {testInfo.bestResult} {testInfo.measureTypeTitle}
                                </div>
                            </div>
                        )
                    ) : testInfo.currentResult > testInfo.bestResult ? (
                        <div className={styles.results}>
                            <div className={styles.currentResult}>
                                {testInfo.currentResult} {testInfo.measureTypeTitle} |
                            </div>
                            <div className={styles.bestResult}>
                                {testInfo.bestResult} {testInfo.measureTypeTitle}
                            </div>
                        </div>
                    ) : (
                        <div className={styles.currentResult}>
                            {testInfo.currentResult} {testInfo.measureTypeTitle} (лидер)
                        </div>
                    )}
                </div>
                <div className={styles.normal}>
                    {testInfo.normalResult !== 0 ? (
                        <span>
                            {" "}
                            норм. {testInfo.normalResult} {testInfo.measureTypeTitle}{" "}
                        </span>
                    ) : (
                        <span>&nbsp;</span>
                    )}
                </div>
            </div>
            {testInfo.previousResult !== 0 ? (
                <div className={styles.previousResults}>
                    <div className={styles.normal}>
                        Прош. раз: {testInfo.previousResult} {testInfo.measureTypeTitle}
                    </div>
                    <div className={styles.difference}>
                        {testInfo.moreIsBetter ? (
                            testInfo.currentResult >= testInfo.previousResult ? (
                                <div className={styles.green}>
                                    ({svgIcons.arrowUp}{" "}
                                    {Math.round(
                                        ((testInfo.currentResult - testInfo.previousResult) /
                                            testInfo.previousResult) *
                                            100,
                                    )}
                                    %)
                                </div>
                            ) : (
                                <div className={styles.red}>
                                    ({svgIcons.arrowDown}{" "}
                                    {Math.round(
                                        ((testInfo.previousResult - testInfo.currentResult) /
                                            testInfo.currentResult) *
                                            100,
                                    )}
                                    %)
                                </div>
                            )
                        ) : testInfo.currentResult <= testInfo.previousResult ? (
                            <div className={styles.green}>
                                ({svgIcons.arrowUp}{" "}
                                {Math.round(
                                    ((testInfo.previousResult - testInfo.currentResult) /
                                        testInfo.currentResult) *
                                        100,
                                )}
                                %)
                            </div>
                        ) : (
                            <div className={styles.red}>
                                ({svgIcons.arrowDown}{" "}
                                {Math.round(
                                    ((testInfo.currentResult - testInfo.previousResult) /
                                        testInfo.previousResult) *
                                        100,
                                )}
                                %)
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className={styles.previousResults} />
            )}
        </div>
    );
}

TestCard.propTypes = {
    testInfo: exact({
        title: PropTypes.string.isRequired,
        moreIsBetter: PropTypes.bool.isRequired,
        measureTypeTitle: PropTypes.string.isRequired,
        currentResult: PropTypes.number.isRequired,
        previousResult: PropTypes.number.isRequired,
        bestResult: PropTypes.number.isRequired,
        normalResult: PropTypes.number.isRequired,
    }).isRequired,
};
